import React from "react";
import { node, string } from "prop-types";

import * as S from "./styled";

const InquirySuccess = ({
  ariaContentDescribedBy,
  ariaContentLabelledBy,
  children,
  className,
  titleText
}) => (
  <S.Content className={className}>
    <S.SuccessMessageContainer>
      <S.CheckMarkContainer>
        <S.CheckMark />
      </S.CheckMarkContainer>
      <S.SuccessTitle id={ariaContentLabelledBy}>{titleText}</S.SuccessTitle>
      <S.SuccessTextContainer>
        <S.SuccessText id={ariaContentDescribedBy}>{children}</S.SuccessText>
      </S.SuccessTextContainer>
    </S.SuccessMessageContainer>
  </S.Content>
);

InquirySuccess.propTypes = {
  ariaContentLabelledBy: string,
  ariaContentDescribedBy: string,
  className: string,
  children: node,
  titleText: string
};

InquirySuccess.defaultProps = {
  ariaContentLabelledBy: null,
  ariaContentDescribedBy: null,
  className: "",
  children: null,
  titleText: "Your inquiry has been submitted successfully!"
};

export default InquirySuccess;
